import { heroStats, entryCategories } from "@/mocks/homeContent";

export default function Hero() {
  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20editorial%20newsroom%20background%20with%20deep%20charcoal%20tones%2C%20subtle%20crimson%20accent%20light%20glow%20from%20the%20side%2C%20layered%20ink%20texture%20and%20fine%20paper%20grain%2C%20abstract%20investigative%20mood%2C%20soft%20spotlight%2C%20minimal%20and%20atmospheric%2C%20cinematic%20drama%20with%20gentle%20chiaroscuro%2C%20high%20detail%20photographic%20yet%20stylized%20concept&width=1600&height=900&seq=exposure-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/60 to-foreground-950/90"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-16 pt-28 text-center md:px-8 md:pt-40">
        <div className="inline-flex items-center gap-2 rounded-full border border-background-200/30 bg-white/5 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
          <span className="flex h-2 w-2 rounded-full bg-primary-500"></span>
          公开信息 · 素材征集 · 合规导航
        </div>

        <h1 className="mt-6 max-w-4xl font-display text-3xl font-bold leading-tight tracking-tight text-background-50 md:text-5xl md:leading-tight">
          曝光导航，让每一条真实线索
          <span className="text-primary-400">抵达应去之处</span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
          集中汇总爆料入口与投稿渠道，提供信息来源与线索征集方式。面向掌握公开事实的内容提供者，我们以规范、审慎、可追溯的方式承接每一项素材。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-700"
          >
            我要提交线索
            <i className="ri-send-plane-fill"></i>
          </a>
          <a
            href="#entries"
            className="inline-flex items-center gap-2 rounded-md border border-background-200/40 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-white/10"
          >
            浏览快速入口
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-3 gap-4 border-t border-background-200/20 pt-8">
          {heroStats.map((s) => (
            <div key={s.label} className="text-center">
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-display text-2xl font-bold text-background-50 md:text-3xl">
                {s.value}
              </dd>
              <dd className="mt-1 text-xs text-background-300 md:text-sm">{s.label}</dd>
            </div>
          ))}
        </dl>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-2.5">
          {entryCategories.map((c) => (
            <span
              key={c.label}
              className="inline-flex items-center gap-2 rounded-full border border-background-200/20 bg-white/5 px-3 py-1.5 text-xs text-background-100"
            >
              {c.label}
              <b className="text-accent-300">{c.count}</b>
              <span className="text-background-400">{c.note}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}